/**
 * External dependencies
 */

import isEmpty from 'lodash/isEmpty';

/**
 * React dependencies
 */

import React, { useEffect, useState } from 'react';

/**
 * DWT dependencies
 */

/**
 * DWT hooks
 */

import useMediaQuery from '../../../hooks/useMediaQuery';
import useFilterForCheckbox from '../useFilterForCheckbox';

/**
 * DWT components
 */

import Checkbox from '../../UI/Checkbox';
import FilterResetButton from '../FilterResetButton';
import FilterTitle from '../FilterTitle';

/**
 * FilterPostListItem
 *
 * Renders a list item for each post type ( bookcategory, imprint );
 * Just two post types now. Refactor to accommodate more if needed
 *
 * @param {Object} props
 * @param {string} props.context
 * @param {Object} props.setStart
 * @param {string} props.dataCode
 * @param {string} props.title
 * @param {Array} props.data
 */
const FilterPostItem = ({ context, setStart, filterPostType, dataCode, title, data, scrollToTop, contributorsListing }) => {
  const isDesktop = useMediaQuery( '( min-width: 1024px )' );
  const code = filterPostType === 'bookcategory' ? context.categoryCode : context.imprintCode;
  const [ isActive, setIsActive ] = useState( !!code );
  const trimCode = code?.replace( /\s/g, '' )?.replace( /^,|,$/g, '' );
  const sortCode = ( str ) => str?.split( ',' ).sort();
  const {
    checked,
    setChecked,
    handleFilter,
    initialObj
  } = useFilterForCheckbox( setStart, dataCode, scrollToTop, trimCode );

  useEffect( () => {
    if ( !isActive && isDesktop && contributorsListing && dataCode === 'data-category-code' ) {
      setIsActive( true );
    }
  }, [ isDesktop ] );

  const getCheckedState = ( item ) => {
    if ( isEmpty( checked ) ) return '';
    return filterPostType === 'bookcategory' ? checked[item.ACF?.bisac] : checked[sortCode( item.ACF?.imprint_code )];
  };

  const filterTitleClickHandler = () => {
    setIsActive( cur => !cur );
  };

  return (
    data.length > 0 && (
      <li className={ `filters__list-item text-[#121212] ${isActive ? 'is-active' : 'is-inactive'} ` }>
        <FilterTitle title={ title } onClick={ filterTitleClickHandler } />
        <ul className={ `filters__submenu text-14 flex flex-col gap-15 list-none mb-20 pl-0 ml-0 ${data?.length > 7 ? 'lg:h-[267px] lg:overflow-y-scroll' : 'lg:h-auto'}` }>
          { data.map( ( item ) => (
            item?.status === 'publish' && (
              <li
                className="submenu__list-item mb-0"
                data-slug={ item.slug }
                data-post-type={ item.type }
                key={ self.crypto.randomUUID() }
              >
                <Checkbox
                  obj={ item }
                  id={ item.slug }
                  name={ item.slug }
                  checked={ getCheckedState( item ) }
                  value={ filterPostType === 'bookcategory' ? item.ACF?.bisac : sortCode( item.ACF?.imprint_code ) }
                  onChange={ handleFilter }
                />
              </li>
            )
          ) ) }
        </ul>
        <FilterResetButton setStart={ setStart } checked={ checked } setChecked={ setChecked } dataFilter={ dataCode } scrollToTop={ scrollToTop } initialObj={ initialObj } />
      </li>
    )
  );
};

export default FilterPostItem;
